import React from 'react';
import GitHubIcon from '@material-ui/icons/GitHub';
import LiveIcon from '@material-ui/icons/Info';
import CodeIcon from '@material-ui/icons/Code';

const Service = () => {
    return (
        <div id='project' className='bg-about lg:p-10 p-5'>
            <div className='lg:grid grid-cols-3 gap-10'>
                <div className='bg-card  mt-5 rounded' data-aos='zoom-in'>
                    <img src="https://mobirise.com/assets52/images/temps-3.jpg" alt="" />
                    <p className='text-white font-bold  text-center mt-5 mb-3'>Doctor App React</p>
                    <div className='flex justify-between items-center p-5 text-white'>
                        <a href="#"><GitHubIcon></GitHubIcon> <small className='font-bold text-green-400 block mt-2'>Code</small></a>
                        <a href="#"><LiveIcon></LiveIcon><small className='font-bold text-green-400 block mt-2'>Info</small></a>
                        <a href="#"><CodeIcon></CodeIcon><small className='font-bold text-green-400 block mt-2'>Live</small></a>
                    </div>
                </div>
                <div className='bg-card mt-5 rounded' data-aos='zoom-in'>
                    <img src="https://mobirise.com/assets52/images/temps-3.jpg" alt="" />
                    <p className='text-white font-bold  text-center mt-5 mb-3'>Doctor App React</p>
                    <div className='flex justify-between items-center p-5 text-white'>
                        <a href="#"><GitHubIcon></GitHubIcon> <small className='font-bold text-green-400 block mt-2'>Code</small></a>
                        <a href="#"><LiveIcon></LiveIcon><small className='font-bold text-green-400 block mt-2'>Info</small></a>
                        <a href="#"><CodeIcon></CodeIcon><small className='font-bold text-green-400 block mt-2'>Live</small></a>
                    </div>
                </div>
                <div className='bg-card mt-5 rounded' data-aos='zoom-in'>
                    <img src="https://mobirise.com/assets52/images/temps-3.jpg" alt="" />
                    <p className='text-white font-bold  text-center mt-5 mb-3'>Doctor App React</p>
                    <div className='flex justify-between items-center p-5 text-white'>
                        <a href="#"><GitHubIcon></GitHubIcon> <small className='font-bold text-green-400 block mt-2'>Code</small></a>
                        <a href="#"><LiveIcon></LiveIcon> <small className='font-bold text-green-400 block mt-2'>Info</small></a>
                        <a href="#"><CodeIcon></CodeIcon> <small className='font-bold text-green-400 block mt-2'>Live</small></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service;